<div class="dialog-panel">
  <div class="dialog-content">
    <div class="dialog-header">
      <h1 class="dialog-title">{{ 'users_setup.account_created_title' | transloco }}</h1>
    </div>
    <div class="dialog-body">
      <p class="info">{{ 'users_setup.account_created_success' | transloco }}</p>
      <p class="info" [innerHTML]="'users_setup.pin_code_sent' | transloco"></p>
      <i>{{ 'users_setup.email_not_received' | transloco }}</i>
    </div>
  </div>
</div>
